import React, { useEffect } from "react";
import { useState } from "react";
import Cookies from "js-cookie";

import { Col, Row } from "react-bootstrap";
import Container from "react-bootstrap/Container";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { Link, Navigate } from "react-router-dom";

import { PALETTE } from "../../common/ThemeConstants";
import { getRequest, postRequest } from "../../api/axiosRequests";
import LineSeparator from "../../common/components/LineSeparator";
import RegistrationHeader from "../components/RegistrationHeader";
import ContainerResponsive from "../../common/components/ContainerResponsive";

export default function Register() {
  const [USER, ADMIN, NONE] = ["User", "Admin", "None"];
  const [firstname, setFirstname] = useState("");
  const [lastname, setLastname] = useState("");
  const [birthdate, setBirthdate] = useState("");
  const [cf, setCf] = useState("");
  const [sex, setSex] = useState("M");
  const [height, setHeight] = useState(0);
  const [weight, setWeight] = useState(0);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const [logged, setLogged] = useState(NONE);

  async function registerPostRequest(data) {
    const csrftoken = Cookies.get("csrftoken");
    const headers = { "X-CSRFToken": csrftoken };
    const response = await postRequest("register/", data, headers);
    return response;
  }

  const handleSubmit = (event) => {
    event.preventDefault();

    const data = {
      firstname: firstname,
      lastname: lastname,
      birthdata: birthdate,
      cf: cf,
      sex: sex,
      height: height,
      weight: weight,
      email: email,
      password: password,
    };
    registerPostRequest(data)
      .then((result) => {
        event.target.submit();
      })
      .catch((err) => {
        console.log(err);
        event.stopPropagation();
      });
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    const headers = { Authorization: localStorage.getItem("jwt") };
    const promiseUser = getRequest("userData/", headers);

    promiseUser
      .then((res) => {
        // const user = res.data['data']
        const role = res.data["role"];

        if (role === "User") {
          setLogged(USER);
        } else if (role === "Admin") {
          setLogged(ADMIN);
        } else {
          setLogged(NONE);
        }
      })
      .catch((errs) => {
        console.log(errs);
        if (errs.response) {
          setLogged(NONE);
        }
      });
  }, []);

  return (
    <>
      {(logged === USER || logged === ADMIN) && <Navigate to="/account" />}
      {logged === NONE && (
        <>
          <RegistrationHeader />
          <ContainerResponsive>
            <Container className="m-auto">
              <Container style={{ maxWidth: "400px" }}>
                <h2>Crea un nuovo account</h2>
                <Form
                  className="py-3 mb-0"
                  onSubmit={handleSubmit}
                  action="/login"
                >
                  <Row>
                    <Col className="px-1">
                      <Form.Group className="mb-3" controlId="formFirstname">
                        <Form.Label className="settings-form-label">Nome</Form.Label>
                        <Form.Control
                          type="text"
                          value={firstname}
                          onChange={(event) => {
                            setFirstname(event.target.value);
                          }}
                          style={{ border: "2px solid #f2f2f2", borderRadius: 10 }}
                          placeholder=""
                          required
                        />
                      </Form.Group>
                    </Col>
                    <Col className="px-1">
                      <Form.Group className="mb-3" controlId="formLastname">
                        <Form.Label className="settings-form-label">Cognome</Form.Label>
                        <Form.Control
                          type="text"
                          value={lastname}
                          onChange={(event) => {
                            setLastname(event.target.value);
                          }}
                          style={{ border: "2px solid #f2f2f2", borderRadius: 10 }}
                          placeholder=""
                          required
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col className="px-1">
                      <Form.Group className="mb-3" controlId="formFirstname">
                        <Form.Label className="settings-form-label">Data di nascità</Form.Label>
                        <Form.Control
                          type="date"
                          value={birthdate}
                          onChange={(event) => {
                            setBirthdate(event.target.value);
                          }}
                          style={{ border: "2px solid #f2f2f2", borderRadius: 10 }}
                          placeholder=""
                          required
                        />
                      </Form.Group>
                    </Col>
                    <Col className="px-1">
                      <Form.Group className="mb-3" controlId="formFirstname">
                        <Form.Label className="settings-form-label">Sesso</Form.Label>
                        <Form.Select
                          aria-label="sex"
                          onChange={(event) => {
                            setSex(event.target.value);
                          }}
                          value={sex}
                          style={{ borderRadius: 10 }}
                        >
                          <option key={"M"} value={"M"}>
                            {"Maschio"}
                          </option>
                          <option key={"F"} value={"F"}>
                            {"Femmina"}
                          </option>
                        </Form.Select>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col className="px-1">
                      <Form.Group className="mb-3">
                        <Form.Label className="settings-form-label">Altezza (CM)</Form.Label>
                        <Form.Control
                          type="number"
                          autoComplete="height"
                          value={height}
                          onChange={(event) => {
                            setHeight(event.target.value);
                          }}
                          style={{
                            border: "2px solid #f2f2f2",
                            borderRadius: 10,
                          }}
                          placeholder=""
                          required
                        />
                      </Form.Group>
                    </Col>
                    <Col className="px-1">
                      <Form.Group className="mb-3">
                        <Form.Label className="settings-form-label">Peso (KG)</Form.Label>
                        <Form.Control
                          type="number"
                          autoComplete="weight"
                          value={weight}
                          onChange={(event) => {
                            setWeight(event.target.value);
                          }}
                          style={{
                            border: "2px solid #f2f2f2",
                            borderRadius: 10,
                          }}
                          placeholder=""
                          required
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col className="px-1">
                      <Form.Group className="mb-3" controlId="formLastname">
                        <Form.Label className="settings-form-label">Codice Fiscale</Form.Label>
                        <Form.Control
                          type="text"
                          value={cf}
                          onChange={(event) => {
                            setCf(event.target.value);
                          }}
                          style={{ border: "2px solid #f2f2f2", borderRadius: 10 }}
                          placeholder=""
                          required
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col className="px-1">
                      <Form.Group className="mb-3" controlId="formEmail">
                        <Form.Label className="settings-form-label">Email</Form.Label>
                        <Form.Control
                          type="email"
                          autoComplete="username"
                          value={email}
                          onChange={(event) => {
                            setEmail(event.target.value);
                          }}
                          style={{ border: "2px solid #f2f2f2", borderRadius: 10 }}
                          placeholder=""
                          required
                        />
                        <Form.Text className="text-muted"></Form.Text>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col className="px-1">
                      <Form.Group className="mb-3" controlId="formPassword">
                        <Form.Label className="settings-form-label">Password</Form.Label>
                        <Form.Control
                          type="password"
                          autoComplete="new-password"
                          value={password}
                          onChange={(event) => {
                            setPassword(event.target.value);
                          }}
                          style={{ border: "2px solid #f2f2f2", borderRadius: 10 }}
                          placeholder=""
                          required
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <p style={{ color: PALETTE.DARK, fontSize: "0.8rem" }}>
                    Cliccando su "CREA ACCOUNT", dichiari di accettare i nostri{" "}
                    <a
                      href="/TermsOfService"
                      style={{
                        color: PALETTE.DARK,
                        textDecoration: "none",
                        fontWeight: "bold",
                      }}
                    >
                      Termini e condizioni
                    </a>{" "}
                    e la nostra{" "}
                    <a
                      href="/PrivacyPolicy"
                      style={{
                        color: PALETTE.DARK,
                        textDecoration: "none",
                        fontWeight: "bold",
                      }}
                    >
                      Informativa sulla privacy
                    </a>
                    .
                  </p>
                  <Button
                    style={{ width: "100%", borderRadius: 20 }}
                    variant="dark"
                    type="submit"
                  >
                    CREA ACCOUNT
                  </Button>
                  <LineSeparator
                    text="O"
                    marginY={30}
                    marginX={10}
                    color="#c5c5c5"
                  />
                  <Link to={"/login"}>
                    <Button
                      className="border-dark"
                      style={{ width: "100%", borderRadius: 20 }}
                      variant="white"
                    >
                      LOGIN
                    </Button>
                  </Link>
                </Form>
              </Container>
            </Container>
          </ContainerResponsive>
        </>
      )
      }
    </>
  );
}
